module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    staticClass: "homepage",
    attrs: {
      "name": "index"
    }
  }, [_c('bc-navbar'), _vm._v(" "), _c('div', {
    staticClass: "homepage-content"
  }, [_c('home-page-slider', {
    attrs: {
      "slides": _vm.homeSlides
    }
  }), _vm._v(" "), _c('bottom-panel', {
    attrs: {
      "referralsCount": _vm.historyLoaded ? _vm.referralsCount : null
    }
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2dcd5dfc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2dcd5dfc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/pages/home/index.page.vue
// module id = 808
// module chunks = 0